/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4eb0b56e"]'><div :class='["checkbox-group-modal-default-demo"]'><cube-checkbox-group-modal ref="__mpx_ref_checkboxModal__" title="我是标题" subtitle="这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述这里是描述" :show-close-icon="(true)" :options="(options)" :values="(value)" @close='(e)=>__invoke(e, [["onClose"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><cube-button @_click="onTap">checkbox-modal-default</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_4eb0b56e"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4eb0b56e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4eb0b56e"}
  /** script content **/
  require("./checkbox-modal-default.mpx.js?isComponent&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./checkbox-modal-default.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4eb0b56e"],
    ctorType: "component",
    outputPath: "components/checkbox-modal-default4eb0b56e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-modal/index.mpx?isComponent&outputPath=components%2Findex37cd7d2c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>